import AliceCarousel from "react-alice-carousel";

import Compensation from "./Compensation";
import SliderStyles from "./SliderStyles";

const CompensationSlider = ({
  compensations,
  global,
  refreshList,
}: {
  global?: boolean;
  compensations: Compensation[];
  refreshList: () => void;
}) => {
  if (compensations.length === 0) {
    return null;
  }

  const items = compensations.map((compensation) => (
    <Compensation
      clamp
      compensation={compensation}
      global={global}
      key={compensation.id}
      refreshList={refreshList}
    />
  ));

  return (
    <SliderStyles>
      <AliceCarousel
        disableDotsControls
        infinite
        activeIndex={Math.floor(Math.random() * items.length)}
        autoPlay={items.length > 1}
        autoPlayInterval={5000}
        disableButtonsControls={items.length === 1}
        items={items}
      />
    </SliderStyles>
  );
};

export default CompensationSlider;
